/* eslint-disable react/prop-types */
import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import { Box, Typography } from "@mui/material";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontWeight: row.bold ? "bold" : 400 }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    onlyTitle: true,
    bold: true,
    index: {
      value: "I",
      bg: true,
    },
    id: {
      value: null,
      bg: true,
    },
    amount: {
      value: null,
      bg: true,
    },
    title: {
      value: "Thu nhập từ chuyển nhượng vốn góp",
      bg: true,
    },
  },
  {
    bold: false,
    index: {
      value: "1",
      bg: false,
    },
    id: {
      value: 37,
      bg: false,
    },
    amount: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Giá chuyển nhượng",
      bg: false,
    },
  },
  {
    bold: false,
    index: {
      value: "2",
      bg: false,
    },
    id: {
      value: 38,
      bg: false,
    },
    amount: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Giá vốn của phần vốn góp chuyển nhượng",
      bg: false,
    },
  },
  {
    bold: false,
    index: {
      value: "3",
      bg: false,
    },
    id: {
      value: 39,
      bg: false,
    },
    amount: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Chi phí chuyển nhượng",
      bg: false,
    },
  },
  {
    bold: false,
    index: {
      value: "4",
      bg: true,
    },
    id: {
      value: 40,
      bg: true,
    },
    amount: {
      value: 0,
      bg: true,
    },
    title: {
      value: "Thu nhập tính thuế từ chuyển nhượng vốn góp [40]=[37]-[38]-[39]",
      bg: true,
    },
  },
  {
    bold: false,
    index: {
      value: "5",
      bg: false,
    },
    id: {
      value: 41,
      bg: false,
    },
    amount: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Số thuế phải nộp [41]=[40]*20%",
      bg: false,
    },
  },
  {
    bold: false,
    index: {
      value: "6",
      bg: false,
    },
    id: {
      value: 42,
      bg: false,
    },
    amount: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Số thuế được miễn giảm theo Hiệp định tránh đánh thuế hai lần",
      bg: false,
    },
  },
  {
    bold: false,
    index: {
      value: "7",
      bg: true,
    },
    id: {
      value: 43,
      bg: true,
    },
    amount: {
      value: 0,
      bg: true,
    },
    title: {
      value: "Số thuế còn phải nộp [43]=[41]-[42]",
      bg: true,
    },
  },
  {
    onlyTitle: true,
    bold: true,
    index: {
      value: "II",
      bg: true,
    },
    id: {
      value: null,
      bg: true,
    },

    amount: {
      value: null,
      bg: true,
    },
    title: {
      value: "Thu nhập từ chuyển nhượng chứng khoán",
      bg: true,
    },
  },
  {
    bold: false,
    index: {
      value: "1",
      bg: false,
    },
    id: {
      value: 44,
      bg: false,
    },
    amount: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Giá chuyển nhượng",
      bg: false,
    },
  },
  {
    bold: false,
    index: {
      value: "2",
      bg: false,
    },
    id: {
      value: 45,
      bg: false,
    },
    amount: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Số thuế phải nộp [45]=[44]*0.1%",
      bg: false,
    },
  },
  {
    bold: false,
    index: {
      value: "3",
      bg: false,
    },
    id: {
      value: 46,
      bg: false,
    },
    amount: {
      value: 0,
      bg: false,
    },
    title: {
      value: "Số thuế được miễn giảm thoe Hiệp định tránh đánh thuế hai lần",
      bg: false,
    },
  },
  {
    bold: false,
    index: {
      value: "4",
      bg: true,
    },
    id: {
      value: 47,
      bg: true,
    },
    amount: {
      value: 0,
      bg: true,
    },
    title: {
      value: "Số thuế còn phải nộp [47]=[45]-[46]",
      bg: true,
    },
  },
];

function TaxPersonalTable2({ setFieldValue }) {
  const [data, setData] = useState(dataTable);
  const dataTableMemo = useMemo(() => {
    return dataTable;
  }, []);

  useEffect(() => {
    setFieldValue("valuesTableIV", data);
  }, [data]);

  const handleChange = useCallback((values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  }, []);

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Typography mb={1} variant="h5">
        IV. CHI TIẾT TÍNH THUẾ
      </Typography>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }}>STT</Th>
              <Th style={{ textAlign: "center" }}>Chi tiêu</Th>
              <Th style={{ textAlign: "center" }}>Mã chi tiêu</Th>
              <Th style={{ textAlign: "center" }}>Số tiền</Th>
            </tr>
          </thead>
          <tbody>
            {dataTableMemo &&
              dataTableMemo.length > 0 &&
              dataTableMemo.map((row, index) => (
                <tr key={row.index.value + index}>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.index.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.index.value}
                  </Td>
                  <Td
                    row={row}
                    colSpan={row.onlyTitle ? 4 : 1}
                    style={{
                      textAlign: "left",
                      background: !row.index.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.title.value}
                  </Td>
                  {!row.onlyTitle && (
                    <>
                      <Td
                        row={row}
                        style={{
                          textAlign: "center",
                          background: !row.id.bg ? "transparent" : "#ddeff3",
                        }}
                      >
                        {row.id.value}
                      </Td>
                      <Td
                        row={row}
                        style={{
                          textAlign: "right",
                          background: !row?.amount?.bg ? "transparent" : "#ddeff3",
                        }}
                      >
                        {row?.amount?.bg ? (
                          row.amount.value
                        ) : (
                          <MemoizedInputTable
                            id={row.id.value}
                            name="amount"
                            value={row?.amount?.value}
                            onChange={handleChange}
                          />
                        )}
                      </Td>
                    </>
                  )}
                </tr>
              ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

export default memo(TaxPersonalTable2);

function InputTable(props) {
  const { id, onChange, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}

const MemoizedInputTable = memo(InputTable);
